<template>
    <a-layout id="components-layout-demo-top" class="layout">
        <a-layout-content style="padding: 20vh 33vw">
            <slide-y-up-transition mode="out-in" origin="center top">
                <div v-if="show" :style="{ background: '#fff', padding: '24px', minHeight: '50vh' }">
                     <router-view></router-view>
            </div>
            </slide-y-up-transition>
        </a-layout-content>
        <a-layout-footer style="text-align: center">
            &copy; {{year}} <a href="mailto:info@bigeron.com" class="font-weight-bold ml-1" target="_blank">bigeron.com</a>
        </a-layout-footer>
    </a-layout>
</template>
<script>
import { SlideYUpTransition } from 'vue2-transitions'
import {Icon, Layout} from 'ant-design-vue'
import ARow from 'ant-design-vue/es/grid/Row'
import ACol from 'ant-design-vue/es/grid/Col'

export default {
  name: 'auth-layout',
  components: {
    SlideYUpTransition,
    ACol,
    ARow,
    'a-layout': Layout,
    'a-layout-footer': Layout.Footer,
    'a-layout-header': Layout.Header,
    'a-layout-content': Layout.Content,
    'a-icon': Icon
  },
  data () {
    this.$i18n.locale = 'sk'
    return {
      year: new Date().getFullYear(),
      showMenu: false,
      show: true
    }
  },
}
</script>
<style scoped>
    body
    {    background-color: #f0f2f5;
        height:100vh;
    }
    .logo
    {width:350px;margin:0 auto;}
    .logo svg
    {max-height:10vh;}
    footer
    {background-color: #172b4d;}
    footer .container
    {
        height: 70vh;
    }
    .ant-layout-header {
        height: 10vh;
    } .ant-layout-footer {
          height: 10vh;
      }
    .cls-1{fill:#fff;}.cls-2{fill:#f7941d;}.cls-3{fill:#ee202e;}
</style>



// WEBPACK FOOTER //
// src/layout/AuthLayout.vue